import React from 'react';
import PropTypes from 'prop-types';

function Label({
  htmlFor = '',
  labelName = '',
  className = '',
  style = {},
}) {
  return (
    <label htmlFor={htmlFor} style={style} className={className}>
      {labelName}
    </label>
  );
}

Label.propTypes = {
  htmlFor: PropTypes.string,
  labelName: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.shape({}),
};

export default Label;
